import React from 'react';
import './Searchbar.css';

import { PersonFileInfo, Sex } from 'lib/Types';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';

interface Props{
    person: PersonFileInfo;
    removeClicked(person: PersonFileInfo): void;
}

class MultisearchItem extends React.Component<Props, {}> {
    render() {
        let value = `${this.props.person.person.name}`;

        return (
            <div className="multisearch-item" key={`${this.props.person.person.name}-${this.props.person.person.sex}`}>
                {value}
                {this.props.person.person.sex ? (this.props.person.person.sex === Sex.Male ? <MaleIcon className='gender-symbol'/> : <FemaleIcon className='gender-symbol'/>) : ""}
                <input type='button' value="&#x2716;" onClick={() => this.props.removeClicked(this.props.person)} />
            </div>
        );
    }
}

export default MultisearchItem;